'use client';
import { clsx } from 'clsx';
import { useScrollNavigation } from 'hooks/useScrollNavigation';
import type { PropsWithClassName } from 'types/react-props';
import { slugify } from 'utils/string';
import { Icon } from '../Icon';
import Link from '../Link/Link';
import { RtlPlusLogo } from '../Logo';
import styles from './EpgEventTeaser.module.scss';

type Item = {
  readonly channelName: string;
  readonly showName: string;
};
export type EpgEventTeaserProps = PropsWithClassName<{
  readonly items: ReadonlyArray<Item>;
}>;

const CHANNEL_LINKS: Record<string, string> = {
  RTL: 'rtl-1',
  VOX: 'vox-4',
  NITRO: 'nitro-3',
  RTLup: 'rtlup-12',
  'RTL Passion': 'rtl-passion-9',
  'RTL Living': 'rtl-living-7',
  'RTL Crime': 'rtl-crime-8',
  VOXup: 'voxup-15',
};

export const EpgEventTeaser = ({ items, className }: EpgEventTeaserProps) => {
  const { listRef, canScrollLeft, canScrollRight, scroll } = useScrollNavigation();

  return (
    <div className={clsx(styles.root, className)}>
      <Link
        className={styles.rtlPlus}
        href="https://plus.rtl.de/?utm_source=rtl&utm_medium=owned&utm_campaign=teaser_rtl-plus-event&utm_term=live_logo"
        target="_blank"
        plainLink
      >
        <span aria-hidden="true">
          <strong>LIVE</strong> <span className={styles.textHidden1}>streamen </span>
          <span className={styles.textHidden2}>auf</span>
        </span>
        <RtlPlusLogo className={styles.logo} colors={['#fff', '#fff', '#fff']} />
      </Link>
      <div ref={listRef} className={styles.channels}>
        {items.map(({ channelName, showName }) => (
          <Link
            key={channelName}
            className={styles.showItem}
            href={`https://plus.rtl.de/video-tv/live-tv/${CHANNEL_LINKS[channelName] || 'rtl-1'}?utm_source=rtl&utm_medium=owned&utm_campaign=teaser_rtl-plus-event&utm_term=${slugify(showName)}`}
            target="_blank"
            plainLink
          >
            <div>{channelName}</div>
            <div className={styles.showTitle}>{showName}</div>
          </Link>
        ))}
      </div>
      <div className={styles.navigation}>
        <button
          className={styles.navButton}
          onClick={() => scroll('prev')}
          aria-label="Zum vorherigen Sender scrollen"
          disabled={!canScrollLeft}
        >
          <Icon name="chevronLeft" />
        </button>
        <button
          className={styles.navButton}
          onClick={() => scroll('next')}
          aria-label="Zum nächsten Sender scrollen"
          disabled={!canScrollRight}
        >
          <Icon name="chevronRight" />
        </button>
      </div>
    </div>
  );
};
